import { KeyRound } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface EmptyTokenStateProps {
  onCreateToken?: () => void;
}

const docsUrl = import.meta.env.VITE_DOCS_URL ?? "https://kopai.app";

export function EmptyTokenState({ onCreateToken }: EmptyTokenStateProps) {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-12 text-center gap-4">
        <div className="rounded-full bg-muted p-3">
          <KeyRound className="size-6 text-muted-foreground" />
        </div>
        <div className="flex flex-col gap-1">
          <h3 className="font-semibold">No tokens yet</h3>
          <p className="text-sm text-muted-foreground max-w-sm">
            Create a backend token to start ingesting traces, logs, and metrics.
          </p>
        </div>
        {onCreateToken && (
          <div className="flex flex-col items-center gap-2">
            <Button onClick={onCreateToken}>Generate your first token</Button>
            <a
              href={`${docsUrl}/docs/kopai-cloud/`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-muted-foreground hover:text-foreground"
            >
              View setup guide →
            </a>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
